import angular from 'angular';
import { sqSearchResultService } from '@/hybrid/search/searchResult.utilities.service';

const dependencies = ['Sq.Vendor', 'Sq.Core', 'Sq.Workbook', 'Sq.Worksheet', 'Sq.AssetGroups'];

angular.module('Sq.Search', dependencies).service('sqSearchResultService', sqSearchResultService);
